module.exports = __webpack_public_path__ + "media/images/baslow2-6173549d71a93d0c0bfb0a0099343fce.jpg";